import dayjs from "dayjs";
import api from "./api";

export async function verificaPermissaoDeAcesso(id_paciente, id_vinculo) {
  try {
    const { data } = await api.post("/verifica-permissao/", {
      id_paciente,
      id_vinculo,
    });

    return data;
  } catch (error) {
    console.error("Ocorreu um erro:", error.message);
  }
}

export async function isPatientANJO(id_paciente) {
  try {
    const { data } = await api.post(`/dados-sensores/${id_paciente}`);
    // Pelos menos um sensor
    if (!!data?.error) {
      return false;
    }
    if (Object.entries(data).some(([_, values]) => values.valores.length > 0)) {
      return true;
    }
    return false;
  } catch (error) {
    console.error("Ocorreu um erro:", error.message);
    return false;
  }
}

export async function isTodayMultidisciplinaryConsultation(id_paciente) {
  try {
    const { data } = await api.get(`agenda-paciente/${id_paciente}`, {
      params: {
        is_paciente: true,
        status: "2",
        data: dayjs().format("YYYY-MM-DD"),
      },
    });
    const response = data[0];
    if (!response) return false;
    const today = dayjs().format("YYYY-MM-DD");
    const consultationDate = dayjs(response.dataConsulta.split("T")[0]).format(
      "YYYY-MM-DD"
    );

    if (response.participantes.length > 1 && today === consultationDate) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Ocorreu um erro:", error.message);
    return false;
  }
}

export async function getAppointmentInProgress(id, vinculoId) {
  try {
    const { data } = await api.post(`/checar-consulta-em-andamento/`, {
      id_paciente: id,
      id_vinculo: vinculoId,
    });

    if (typeof data === "boolean") return data;
    return false;
  } catch (error) {
    console.error("Ocorreu um erro:", error.message);
    return false;
  }
}
